// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-loader:not(:empty) {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.component-loader:not(:empty):before,\n.component-loader:not(:empty):after {\n  content: ' ';\n  display: table;\n}\n", ""]);
// Exports
module.exports = exports;
